<template>
  <div class="Applystep-warp">
    <label class="title">{{$t('报名流程')}}</label>
    <div class="list-check">
      <div class="col-1" v-for="(item, index) in stepData" :key="index">
        <hr :style="{'border-bottom':'2px dashed '+ (curStep >= item.step ? '#d60701':'#ccc')}">
        <p>
          <span class="number" :style="{background: curStep >= item.step? '#d60701':''}">{{index+1}}</span>
          <span class="title-name">{{$t(item.title)}}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
export default {
  name: 'joinStep',
  props: {
    programId: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      stepData: [],
      matchInfo: store.getters['match/matchInfo'],
      curStep: 1,
      agencyId: Number(this.$route.query.agencyId)
    }
  },
  mounted () {
    this.curStep = this.$route.query.step
    this.createData()
  },
  methods: {
    createData () {
      // 个人报名
      if (this.matchInfo.joinType === 3) {
        this.stepData = [
          { title: '选手报名', step: 3 },
          { title: this.matchInfo.signCostStatus === 'FREE' ? '参赛选手' : '缴纳费用', step: 4 },
          { title: '资料下载', step: 5 }
        ]
      } else if (this.matchInfo.joinChannel === 'bigball') { // 大球类报名
        this.stepData = [
          { title: '选择单位', step: 1 },
          { title: '选手报名', step: 2 },
          { title: this.matchInfo.signCostStatus === 'FREE' ? '参赛选手' : '缴纳费用', step: 3 },
          { title: '资料下载', step: 4 }
        ]
      } else {
        if (this.matchInfo.joinType === 4 && this.agencyId === -1) {
          this.stepData = [
            { title: '选择单位', step: 1 },
            { title: '选手报名', step: 3 },
            { title: this.matchInfo.signCostStatus === 'FREE' ? '参赛选手' : '缴纳费用', step: 4 },
            { title: '报名完成/下载凭证', step: 5 }
          ]
        } else {
          // 判断是否是线上报名
          if (this.matchInfo.mode === 'ONLINE') {
            this.stepData = [
              { title: '选择单位', step: 1 },
              { title: '选手报名', step: 3 },
              { title: this.matchInfo.signCostStatus === 'FREE' ? '参赛选手' : '缴纳费用', step: 4 },
              { title: '报名完成/下载凭证', step: 5 }
            ]
          } else {
            this.stepData = [
              { title: '选择单位', step: 1 },
              { title: '录入领队及教练', step: 2 },
              { title: '选手报名', step: 3 },
              { title: this.matchInfo.signCostStatus === 'FREE' ? '参赛选手' : '缴纳费用', step: 4 },
              { title: '报名完成/下载凭证', step: 5 }
            ]
          }
        }
      }
      console.log(this.stepData)
    }
  },
  watch: {
    $route () {
      this.curStep = this.$route.query.step
      this.agencyId = Number(this.$route.query.agencyId)
      this.createData()
    },
    programId (newValue, oldValue) {
      if (newValue != null) {
        this.createData()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .Applystep-warp{
    height: 70px;
    position: relative;
    .title{
      left: 0;
      position: absolute;
      display: block;
      width: 100px;
      color: #000;
      font-size: 16px;
      line-height: 48px;
    }
    .list-check{
      display: flex;
      flex-direction: row;
      position: absolute;
      left: 100px;
      height: 50px;
      .col-1{
        display: flex;
        align-items: center;
        flex-direction: row;
      }
      p{
        position: relative;
        top: 5px;
        span{
          display: block;
        }
        span.title-name{
          width: 120px;
          left: 50%;
          margin-left: -60px;
          text-align: center;
          position: absolute;
          white-space: nowrap;
          padding: 5px 0;
        }
        span.number{
          width: 30px;
          height: 30px;
          color: #e8e8e8;
          line-height: 30px;
          display: inline-block;
          text-align: center;
          border-radius: 50%;
          background-color: #fff;
          border: 1px solid #e8e8e8;
        }
      }
      hr{
        border: none;
        width: 100px;
        border-bottom: 2px dashed #ccc;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/step/JoinStep.vue